import type { IValidationField } from 'hooks/useValidations/types';
import type { IGenericObject } from 'types';

import requiredPositiveNumber from '../requiredPositiveNumber';

export default function cropPackNumber(field: IValidationField) {
  const { indexedProducts = {}, maxValue, maxNumberOfPacksError } = field?.context || {};

  return requiredPositiveNumber(field).test({
    name: 'max_quantity',
    test: (value, context) => {
      const { parent = {}, path = '' } = context as IGenericObject;

      const { packagedItemReference = '' } = parent;
      const existingQuantity = indexedProducts[packagedItemReference] || 0;
      if (
        packagedItemReference &&
        value &&
        existingQuantity &&
        existingQuantity + value > maxValue
      ) {
        return context.createError({
          message: maxNumberOfPacksError(maxValue - existingQuantity),
          path: path,
        });
      }

      return true;
    },
  });
}
